import { createContext } from "react";
import { ListTableSort } from "sprint-common-web";

import { EpisodeDetails, TvSeasonDetails, TvSeriesDetails } from "../../../../TvSeriesDetails";
import { EpisodeListingFilters } from "../EpisodeListingFilters";
import { EpisodeListingItem } from "../EpisodeListingItem";

interface ISeasonEpisodeListingContext {
    episodesToMerge: EpisodeListingItem[];
    listingItems: EpisodeListingItem[];
    totalItems: number;
    filters: EpisodeListingFilters;
    selectedSeason: TvSeasonDetails;
    selectedTvSeries: TvSeriesDetails;
    clearFilters(): void;
    addNewEpisode(newEpisode: EpisodeDetails): void;
    setSort(sort: ListTableSort): void;
    setPage(page: number): void;
    setPageSize(pageSize: number): void;
    setOrphanedOnly(orphanedOnly?: boolean): void;
    setIncludeMerged(includeMerged?: boolean): void;
    clearEpisodesToMerge(): void;
    addEpisodeToMergeList(episodeItem?: EpisodeListingItem): void;
    removeEpisodeFromMergeList(episodeItem: EpisodeListingItem): void;
    updateListAfterMerge(newEpisodeId: string): Promise<void>;
}

const defaultSeasonPageContext: ISeasonEpisodeListingContext = {} as ISeasonEpisodeListingContext;

export const SeasonEpisodeListingContext = createContext<ISeasonEpisodeListingContext>(defaultSeasonPageContext);
